module.exports = __webpack_public_path__ + "0c59770b5b3fa5a2af4c25cea24c1161.svg";